import React, { FC, createContext } from 'react';

export enum PageType {
  OrgSetup = 'OrgSetup',
  Settings = 'Integrations',
}

export const OrgSetupPageContext = createContext({
  pageType: PageType.Settings,
});

const OrgSetupPageProvider: FC<{ pageType?: PageType; children?: React.ReactNode }> = ({ pageType, children }) => {
  return (
    <OrgSetupPageContext.Provider
      value={{
        pageType: pageType || PageType.Settings,
      }}
    >
      {children}
    </OrgSetupPageContext.Provider>
  );
};

export default OrgSetupPageProvider;
